






















import { computed, defineComponent, ref } from "@vue/composition-api";
import { throttle } from "lodash-es";
import { NSFWSettingsSubjectType } from "@scrile/api-provider/dist/api/NSFWSettingsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import BaseInputRadio from "@/components/BaseInputRadio";

export default defineComponent({
  name: "SafeForWorkStatusSettings",
  components: { BaseInputRadio },
  props: {
    manualSave: { type: Boolean },
    // profile whose setting is edited; admins and managers edit other users' profiles
    userId: { type: String, default: "" },
  },
  setup(props, { emit }) {
    const { authUserStrict } = useAuthUser();
    const subjectId = computed(() => props.userId || authUserStrict.value.id);
    const safeForWork = ref(true);
    const options = [
      { value: true, text: $t("Safe for work, SFW") },
      { value: false, text: $t("Not safe for work, NSFW") },
    ];

    const updateStatus = throttle(async () => {
      await providers.NSFWSettingsProvider.update({
        data: {
          subject: { subjectId: subjectId.value, subjectType: NSFWSettingsSubjectType.PROFILE },
          safeForWork: safeForWork.value,
        },
      });
    }, 500);

    const manualUpdateStatus = (status: boolean) => {
      emit("setStatus", status);
    };

    const onUpdate = (v: boolean) => {
      safeForWork.value = v;
      props.manualSave ? manualUpdateStatus(v) : updateStatus();
    };

    const fetchData = async () => {
      try {
        emit("setLoading", true);
        const response = await providers.NSFWSettingsProvider.search({
          data: { subjects: [{ subjectId: subjectId.value, subjectType: NSFWSettingsSubjectType.PROFILE }] },
        });
        if (!response.length) {
          onUpdate(false);
        } else {
          safeForWork.value = response[0].safeForWork;
        }
      } finally {
        emit("setLoading", false);
      }
    };

    const init = async () => {
      emit("setValid", true);
      emit("setCb", () => updateStatus());
      await fetchData();
    };

    init();

    return { options, safeForWork, onUpdate };
  },
});
